import type { RiskPriority, RiskSeverity, RiskSignal, RiskSubjectType } from "./types";

/**
 * How the console reads a signal: where it links, and what tone it wears.
 * The API says what was seen; this is the one place that says where to
 * look, so a new subject type is one line here rather than a hunt.
 */
export function subjectPath(subject: RiskSignal["subject"], orgId: string): string | null {
  const routes: Partial<Record<RiskSubjectType, string>> = {
    org: `/organizations/${orgId}`,
    user: `/users/${subject.id}`,
    app: `/apps/${subject.id}`,
    database: `/databases?orgId=${orgId}`,
    domain: `/domains?orgId=${orgId}`,
  };
  return routes[subject.type] ?? null;
}

export const SEVERITY_LABEL: Record<RiskSeverity, string> = {
  info: "Info",
  warning: "Warning",
  critical: "Critical",
};

export const SEVERITY_TONE: Record<RiskSeverity, "neutral" | "warn" | "bad"> = {
  info: "neutral",
  warning: "warn",
  critical: "bad",
};

/** `app.abuse_flag` → "app", the area a kind belongs to, for grouping. */
export function kindArea(kind: string): string {
  return kind.split(".")[0] ?? kind;
}

export const AREA_LABEL: Record<string, string> = {
  account: "Account",
  app: "Apps",
  workload: "Workloads",
  database: "Databases",
  domain: "Domains",
  billing: "Billing",
  inference: "Inference",
  quota: "Limits",
};

export const PRIORITY_LABEL: Record<RiskPriority, string> = {
  critical: "Critical",
  high: "High",
  normal: "Normal",
};

export const PRIORITY_TONE: Record<RiskPriority, "neutral" | "warn" | "bad"> = {
  critical: "bad",
  high: "warn",
  normal: "neutral",
};

/** How long a case can be parked, as the menus offer it -- one case, or a page of them. */
export const SNOOZES: { hours: number; label: string }[] = [
  { hours: 4, label: "4 hours" },
  { hours: 24, label: "Tomorrow" },
  { hours: 72, label: "3 days" },
  { hours: 168, label: "A week" },
];
